const validate = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = 'Title field shouldn’t be empty';
  } else if (values && values.title.length > 255) {
    errors.title = 'Max length is 255 characters';
  }
  return errors;
};

export default validate;
